import { Route, RouteComponentProps, Switch } from "react-router-dom";
import { NotFound } from "@app/shared/ErrorPages";
import ClaimsInsightsDashboard from "@app/projects/network-assessment/pci-dashboard/claims-insights/ClaimsInsightsDashboard";

export const ClaimsInsightsRouter: React.FC<React.PropsWithChildren<RouteComponentProps>> = (props: RouteComponentProps) => {
  return (
    <Switch>
      <Route exact={true} path={`${props.match.path}`} component={ClaimsInsightsDashboard} />

      <Route component={NotFound} />
    </Switch>
  );
}
